import { useTranslations } from "next-intl";
import { Dispatch, SetStateAction } from "react";
import ThemeButton from "src/components/button/ThemeButton";
import {
  ValueWithImage,
  periodManagementOptionsData,
} from "src/config/reviewSystemData";
import classNames from "src/helpers/classNames";
import updateOptionsSelected from "src/helpers/updateOptionsSelected";
import Image from "next/image";

interface WhatReviewerUsesForPeriodFormProps {
  periodManagementOptions: ValueWithImage[];
  setPeriodManagementOptions: Dispatch<SetStateAction<ValueWithImage[]>>;
  setReviewStep: Dispatch<SetStateAction<number>>;
  isFormSubmittedOnce: boolean;
}

const WhatReviewerUsesForPeriodForm = ({
  periodManagementOptions,
  setPeriodManagementOptions,
  setReviewStep,
  isFormSubmittedOnce,
}: WhatReviewerUsesForPeriodFormProps) => {
  const t = useTranslations("ReviewForm");
  return (
    <>
      <section className="m-auto flex flex-col items-center gap-10">
        <div className="flex flex-col items-center gap-2">
          <h2 className="text-center text-2xl font-semibold">
            {t("what_do_you_currently_use_period_management")}
          </h2>
          <p className="text-sm text-gray-600">{t("select_all_that_apply")}</p>
        </div>
        <div className="grid grid-cols-6 gap-10">
          {periodManagementOptionsData.map((option: ValueWithImage) => (
            <button
              key={option.value}
              type="button"
              onClick={() =>
                updateOptionsSelected(
                  periodManagementOptions,
                  setPeriodManagementOptions,
                  option
                )
              }
              className={classNames(
                "col-span-2 flex flex-col items-center gap-2 border border-white p-2 hover:border-beige-800",
                periodManagementOptions.some(
                  (item) => item.value === option.value
                )
                  ? "!border-black"
                  : ""
              )}
            >
              <Image
                src={option.image.src}
                alt="period-management-option-icon"
                style={{
                  width: `${option.image.width}px`,
                  height: `${option.image.height}px`,
                }}
                sizes="10rem"
                width={0}
                height={0}
                priority
              />
              <p className="mt-auto text-xs lg:text-sm">{t(option.value)}</p>
            </button>
          ))}
        </div>
      </section>
      <div className="flex self-end">
        {isFormSubmittedOnce ? (
          <ThemeButton
            onClick={() => setReviewStep(9)}
            disabled={periodManagementOptions.length < 1}
          >
            {t("preview_your_review")}
          </ThemeButton>
        ) : (
          <ThemeButton
            onClick={() => setReviewStep((prevstep) => prevstep + 1)}
            disabled={periodManagementOptions.length < 1}
          >
            {t("next")}
          </ThemeButton>
        )}
      </div>
    </>
  );
};

export default WhatReviewerUsesForPeriodForm;
